import { id, Identifiable, list, Project, project, zone } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { reduceZone } from "../zone";
import { reduceList } from "../list";
import {
  handleEditProjectRequest,
  handleEditProjectSuccess,
  handleEditProjectFailure,
} from "./editProject";
import {
  handleEditProjectWeatherReportRequest,
  handleEditProjectWeatherReportSuccess,
  handleEditProjectWeatherReportFailure,
} from "./editProjectWeatherReport";
import {
  handleEditProjectStatusRequest,
  handleEditProjectStatusSuccess,
  handleEditProjectStatusFailure,
} from "./editProjectStatus";
import {
  handleAddProjectExternalLinkRequest,
  handleAddProjectExternalLinkSuccess,
  handleAddProjectExternalLinkFailure,
} from "./addProjectExternalLink";
import {
  handleEditProjectExternalLinkRequest,
  handleEditProjectExternalLinkSuccess,
  handleEditProjectExternalLinkFailure,
} from "./editProjectExternalLink";
import {
  handleRemoveProjectExternalLinkRequest,
  handleRemoveProjectExternalLinkSuccess,
  handleRemoveProjectExternalLinkFailure,
} from "./removeProjectExternalLink";
import {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
} from "./assignTag";
import {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
} from "./removeTag";
import {
  handleValidateTimeRecordsUpToDateRequest,
  handleValidateTimeRecordsUpToDateSuccess,
  handleValidateTimeRecordsUpToDateFailure,
} from "./validateTimeRecordsUpToDate";

const initialState = { ...project, uuid: id };

function propagateEvent(
  project: Identifiable<Project> = initialState,
  event: Event,
): Identifiable<Project> {
  return {
    ...project,
    rootList: reduceList({ ...list, ...project.rootList }, event),
    zone: reduceZone({ ...zone, ...project.zone }, event),
  };
}

const reduceProject = createStateReducer(
  initialState,
  {
    [events.editProjectRequested]: handleEditProjectRequest,
    [events.editProjectSucceeded]: handleEditProjectSuccess,
    [events.editProjectFailed]: handleEditProjectFailure,
    [events.editProjectWeatherReportRequested]:
      handleEditProjectWeatherReportRequest,
    [events.editProjectWeatherReportSucceeded]:
      handleEditProjectWeatherReportSuccess,
    [events.editProjectWeatherReportFailed]:
      handleEditProjectWeatherReportFailure,
    [events.editProjectStatusRequested]: handleEditProjectStatusRequest,
    [events.editProjectStatusSucceeded]: handleEditProjectStatusSuccess,
    [events.editProjectStatusFailed]: handleEditProjectStatusFailure,
    [events.addProjectExternalLinkRequested]:
      handleAddProjectExternalLinkRequest,
    [events.addProjectExternalLinkSucceeded]:
      handleAddProjectExternalLinkSuccess,
    [events.addProjectExternalLinkFailed]: handleAddProjectExternalLinkFailure,
    [events.editProjectExternalLinkRequested]:
      handleEditProjectExternalLinkRequest,
    [events.editProjectExternalLinkSucceeded]:
      handleEditProjectExternalLinkSuccess,
    [events.editProjectExternalLinkFailed]:
      handleEditProjectExternalLinkFailure,
    [events.removeProjectExternalLinkRequested]:
      handleRemoveProjectExternalLinkRequest,
    [events.removeProjectExternalLinkSucceeded]:
      handleRemoveProjectExternalLinkSuccess,
    [events.removeProjectExternalLinkFailed]:
      handleRemoveProjectExternalLinkFailure,
    [events.assignTagRequested]: handleAssignTagRequest,
    [events.assignTagSucceeded]: handleAssignTagSuccess,
    [events.assignTagFailed]: handleAssignTagFailure,
    [events.removeTagRequested]: handleRemoveTagRequest,
    [events.removeTagSucceeded]: handleRemoveTagSuccess,
    [events.removeTagFailed]: handleRemoveTagFailure,
    [events.validateTimeRecordsUpToDateRequested]:
      handleValidateTimeRecordsUpToDateRequest,
    [events.validateTimeRecordsUpToDateSucceeded]:
      handleValidateTimeRecordsUpToDateSuccess,
    [events.validateTimeRecordsUpToDateFailed]:
      handleValidateTimeRecordsUpToDateFailure,
  },
  propagateEvent,
);

export { reduceProject };
